<script setup>
// *************************************
// *****                           *****
// *****  TheHeader.vue：ヘッダー  *****
// *****  Changed                  *****
// *****  by R.Komatsu 2026/03/10  *****
// *****                           *****
// *************************************
import { onMounted, ref } from 'vue'
const visible = ref(true)
const toggle = () => {
	visible.value = !visible.value
}
</script>

<template>
  <header v-if="visible" class="header" @dblclick="toggle">
    <h2></h2>
  </header>
</template>

<style scoped>
.header {
  width: 100%;
  height: 65px;
  background-image: url('@/assets/icons/header.png'); 
  background-size: 1500px 190px; /* 縦の高さを50%に縮小し、横幅は自動調整 */
  background-position: center; /* 画像を中央に配置 */
  background-repeat: no-repeat; /* 繰り返しを無効化 */
  color: white;
  text-align: center;
  padding: 10px 0;
  box-shadow: 0 1px 5px rgba(0,0,0,0.1);
}
</style>
